import { Suspense, lazy } from "react";

// Loaded on demand: the pages use the platform's own page parts, which the
// package entry must not pull in.
const Accounts = lazy(() => import("./Payouts").then((m) => ({ default: m.PaymentAccounts })));
const RunPayments = lazy(() => import("./Payouts").then((m) => ({ default: m.RunPayments })));
const RunState = lazy(() => import("./Payouts").then((m) => ({ default: m.RunPaymentsState })));
const Platform = lazy(() => import("./PlatformPay").then((m) => ({ default: m.PlatformPay })));
const Details = lazy(() => import("./PayDetails").then((m) => ({ default: m.PayDetails })));

const later = (Page) => (props) => (
  <Suspense fallback={null}>
    <Page {...props} />
  </Suspense>
);

// On the organisation's Payouts page: the accounts money leaves from, with
// the page's own buttons; sending a run, in its row; and where its money is,
// under its status.
export const payoutsPage = { header: [later(Accounts)], run: [later(RunPayments)], status: [later(RunState)] };

// A tab of the Platform page: the platform's own accounts, and how much
// they send for each organisation.
export const platformPayTab = {
  key: "pay",
  label: "Payments",
  path: "/platform/payments",
  after: "revenue",
  component: later(Platform),
};

// On a person's own Earnings: how they are paid.
export const payDetailsSection = { key: "pay-details", component: later(Details) };
